// extracted by mini-css-extract-plugin
export default {"addToCartControl":"SY-z","giftCard":"TY-z","btnContainer":"UY-z","cartButton":"VY-z","disabled":"WY-z"};